import { InjectionToken, NgModule } from '@angular/core';
import { storageSync } from '@larscom/ngrx-store-storagesync';
import { extMetaReducers, extModules } from '@mnz-core/modules/store/build-specifics/modules';
import { RouterEffects } from '@mnz-core/modules/store/effects/router.effects';
import { IRootState } from '@mnz-core/modules/store/models/root-state';
import { RouterStoreSerializer } from '@mnz-core/modules/store/router-store.serializer';
import { AppEffects } from '@mnz-store/effects/app.effects';
import * as fromApp from '@mnz-store/reducers/app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, INITIAL_STATE, StoreModule as NgRxStoreModule } from '@ngrx/store';

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<IRootState>>('Root Reducers');

export function reducerFactory(): ActionReducerMap<IRootState> {
  return {
    router: routerReducer,
    app: fromApp.reducer,
  };
}

export function storageSyncReducer(reducer: ActionReducer<IRootState>): ActionReducer<IRootState> {
  return storageSync<IRootState>({
    features: [{ stateKey: 'login', excludeKeys: ['loading', 'messageFail'] }],
    storageError: console.error,
    storageKeySerializer: (key: string) => `5hv4ogbd_${key}`,
    storage: window.sessionStorage,
  })(reducer);
}

@NgModule({
  imports: [
    NgRxStoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers: [...extMetaReducers, storageSyncReducer],
    }),
    ...extModules,
    EffectsModule.forRoot([RouterEffects, AppEffects]),
    StoreRouterConnectingModule.forRoot({
      serializer: RouterStoreSerializer,
    }),
  ],
  providers: [
    {
      provide: ROOT_REDUCERS,
      useFactory: reducerFactory,
    },
    {
      provide: INITIAL_STATE,
      useValue: {
        router: {
          state: {
            url: '/',
            params: {},
            queryParams: {},
          },
          navigationId: 0,
        },
      },
    },
  ],
  exports: [NgRxStoreModule],
})
export class StoreModule {}
